import { render, staticRenderFns } from "./ProdutoCriar.vue?vue&type=template&id=44dbad79"
import script from "./ProdutoCriar.vue?vue&type=script&lang=js"
export * from "./ProdutoCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports